import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const AgeRange = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Age *
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="ageRange"
              onChange={props.handleChangeAgeRange}
              onBlur={props.calculation}
              value={props.ageRange}
              disabled={props.disabled}
            >
              <option value="">Please select</option>
              <option value="25-65">25-65</option>
              <option value="Others">Others</option>
            </select>
      </Col>
    </FormGroup>
  )
}

AgeRange.propTypes = {
  handleChangeAgeRange: PropTypes.func,
  calculation: PropTypes.func,
  ageRange: PropTypes.string,
  disabled: PropTypes.bool
};

export default AgeRange;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/ageRange/AgeRange.js